const NAMESPACE = "automationCreateOrEditRule";

const KEYS = {
    validationRuleHelpText: "validationRuleHelpText",

    setDataSubActionName_text: "setDataSubActionName_text",
    setDataSubActionName_date: "setDataSubActionName_date",
    setDataSubActionName_timestamp: "setDataSubActionName_timestamp",
    setDataSubActionName_integer: "setDataSubActionName_integer",
    setDataSubActionName_decimal: "setDataSubActionName_decimal",
    setDataSubActionName_boolean: "setDataSubActionName_boolean",
    setDataSubActionName_copy: "setDataSubActionName_copy",
    setDataSubActionName_formula: "setDataSubActionName_formula",

    clearDataSubActionName_text: "clearDataSubActionName_text",
    clearDataSubActionName_date: "clearDataSubActionName_date",
    clearDataSubActionName_timestamp: "clearDataSubActionName_timestamp",
    clearDataSubActionName_integer: "clearDataSubActionName_integer",
    clearDataSubActionName_decimal: "clearDataSubActionName_decimal",
    clearDataSubActionName_boolean: "clearDataSubActionName_boolean",

    setDataValueLabel: "setDataValueLabel",
    setDataTrueValue: "setDataTrueValue",
    setDataFalseValue: "setDataFalseValue",
    setDataActionSubTypeLabel: "setDataActionSubTypeLabel",
    setDataAppendConsecutiveNumberLabel: "setDataAppendConsecutiveNumberLabel",
    setDataAppendConsecutiveNumberInfo: "setDataAppendConsecutiveNumberInfo",
    setDataSourceFieldTypeLabel: "setDataSourceFieldTypeLabel",
    setDataSourceFormulaTypeLabel: "setDataSourceFormulaTypeLabel",
    setDataCopySourceLabel: "setDataCopySourceLabel",
    setDataCopyTargetLabel: "setDataCopyTargetLabel",
    setDataCurrentDateTargetLabel: "setDataCurrentDateTargetLabel",
    setDataCurrentTimestampTargetLabel: "setDataCurrentTimestampTargetLabel",
    setDataNormalTargetLabel: "setDataNormalTargetLabel",
    setDataPvStorageAlwaysToFormulaText: "setDataPvStorageAlwaysToFormulaText",
    setDataPvStorageAlwaysToNeverText: "setDataPvStorageAlwaysToNeverText",
    setDataPvStorageFormulaToDifferentFormulaText: "setDataPvStorageFormulaToDifferentFormulaText",
    setDataPvStorageFormulaToNeverText: "setDataPvStorageFormulaToNeverText",

    frequencySectionHeader: "frequencySectionHeader",
    frequencyLabel: "frequencyLabel",
    frequencyOnlyFirstTimeHelpText: "frequencyOnlyFirstTimeHelpText",

    conditionSectionHeader: "conditionSectionHeader",
    conditionValidationLabel: "conditionValidationLabel",
    conditionActionLabel: "conditionActionLabel",

    errorMessageLabel: "errorMessageLabel",

    actionSectionHeader: "actionSectionHeader",
    actionLabel: "actionLabel",

    communicationTemplateHeader: "communicationTemplateHeader",
    statusHeader: "statusHeader",
    connectionConfigurationHeader: "connectionConfigurationHeader",
    connectionConfigurationMissingError: "connectionConfigurationMissingError",
    deadlineHeader: "deadlineHeader",
    deadlineNoteHeader: "deadlineNoteHeader",
    deadlineNoteText: "deadlineNoteText",
    satisfyAllDeadlinesCheckboxHeader: "satisfyAllDeadlinesCheckboxHeader",
    sourceDocumentTemplateHeader: "sourceDocumentTemplateHeader",
    attachmentToGenerateHeader: "attachmentToGenerateHeader",
    xlsxDocumentOption: "xlsxDocumentOption",
    icsDocumentOption: "icsDocumentOption",
    pdfDocumentOption: "pdfDocumentOption",
    wordDocumentOption: "wordDocumentOption",
    channelHeader: "channelHeader",
    signalHeader: "signalHeader",
    accessGroupHeader: "accessGroupHeader",
    removeAllAccessGroupsCheckboxHeader: "removeAllAccessGroupsCheckboxHeader",
    selectReportHeader: "selectReportHeader",
    selectReportMessage: "selectReportMessage",
    selectESignatureEnvelopeHeader: "selectESignatureEnvelopeHeader",
    continueProcessingHeader: "continueProcessingHeader",
    clearDataNormalTargetLabel: "clearDataNormalTargetLabel",
    stopFurtherProcessingInfoText: "stopFurtherProcessingInfoText",
    setDataFieldTVRInfoText: "setDataFieldTVRInfoText",

    chooseOption: "chooseOption"
};
const MESSAGES = {
    [KEYS.validationRuleHelpText]: {
        value:
            "Error messages for validation failures will be shown during form submission" +
            " or in the Current Status panel on the Project's Admin Page during status changes.",
        comment: "Help text for validation rules"
    },
    [KEYS.setDataSubActionName_text]: {
        value: "Write to text field",
        comment: "Name for the 'set data' sub action for text fields"
    },
    [KEYS.setDataSubActionName_date]: {
        value: "Write to date field",
        comment: "Name for the 'set data' sub action for date fields"
    },
    [KEYS.setDataSubActionName_timestamp]: {
        value: "Write to timestamp field",
        comment: "Name for the 'set data' sub action for timestamp fields"
    },
    [KEYS.setDataSubActionName_integer]: {
        value: "Write to integer field",
        comment: "Name for the 'set data' sub action for integer fields"
    },
    [KEYS.setDataSubActionName_decimal]: {
        value: "Write to decimal field",
        comment: "Name for the 'set data' sub action for decimal fields"
    },
    [KEYS.setDataSubActionName_boolean]: {
        value: "Write to boolean field",
        comment: "Name for the 'set data' sub action for boolean fields"
    },
    [KEYS.setDataSubActionName_copy]: {
        value: "Copy data field",
        comment: "Name for the 'set data' sub action that copies fields"
    },
    [KEYS.setDataSubActionName_formula]: {
        value: "Copy result of formula",
        comment: "Name for the 'set data' sub action that copies results of formulas"
    },

    [KEYS.clearDataSubActionName_text]: {
        value: "Clear text field",
        comment: "Name for the 'clear data' sub action for text fields"
    },
    [KEYS.clearDataSubActionName_date]: {
        value: "Clear date field",
        comment: "Name for the 'clear data' sub action for date fields"
    },
    [KEYS.clearDataSubActionName_timestamp]: {
        value: "Clear timestamp field",
        comment: "Name for the 'clear data' sub action for timestamp fields"
    },
    [KEYS.clearDataSubActionName_integer]: {
        value: "Clear integer field",
        comment: "Name for the 'clear data' sub action for integer fields"
    },
    [KEYS.clearDataSubActionName_decimal]: {
        value: "Clear decimal field",
        comment: "Name for the 'clear data' sub action for decimal fields"
    },
    [KEYS.clearDataSubActionName_boolean]: {
        value: "Clear boolean field",
        comment: "Name for the 'clear data' sub action for boolean fields"
    },

    [KEYS.setDataActionSubTypeLabel]: {
        value: "Action subtype",
        comment: "Dropdown label to select action set data subtype"
    },
    [KEYS.setDataValueLabel]: {
        value: "Value to write",
        comment: "Label for the value to write for the set data action"
    },
    [KEYS.setDataTrueValue]: {
        value: "True",
        comment: "True value for set data action"
    },
    [KEYS.setDataFalseValue]: {
        value: "False",
        comment: "False value for set data action"
    },
    [KEYS.setDataAppendConsecutiveNumberLabel]: {
        value: "Append consecutive number",
        comment: "Label for checkbox that enables appending consecutive numbers"
    },
    [KEYS.setDataAppendConsecutiveNumberInfo]: {
        value: "When Append consecutive number is selected, this action rule will only write values to empty data fields.",
        comment: "Information text about not writing to non-empty data fields"
    },

    [KEYS.setDataSourceFieldTypeLabel]: {
        value: "Field Type",
        comment: "Label for the type of field source for the copy data action"
    },
    [KEYS.setDataSourceFormulaTypeLabel]: {
        value: "Formula Type",
        comment: "Label for the source Formula result type for the copy data action"
    },

    [KEYS.setDataCopySourceLabel]: {
        value: "Copy data from",
        comment: "Label for the source of the copy data action"
    },
    [KEYS.setDataCopyTargetLabel]: {
        value: "Copy data to",
        comment: "Label for the target of the copy data action"
    },
    [KEYS.setDataCurrentDateTargetLabel]: {
        value: "Write current date to data field",
        comment: "Label when writing the current date to the selected field"
    },
    [KEYS.setDataCurrentTimestampTargetLabel]: {
        value: "Write current timestamp to data field",
        comment: "Label when writing the current timestamp to the selected field"
    },
    [KEYS.setDataNormalTargetLabel]: {
        value: "Data Field to set",
        comment: "Label for the target of a normal set data action"
    },
    [KEYS.setDataPvStorageAlwaysToFormulaText]: {
        value:
            "The source PV System group always permits storage equipment, but the target group only permits it based on a formula. " +
            "Any storage equipment data in the source group will be copied to the target, but it may not be appropriate for the project.",
        comment:
            "Warning text displayed for a Set Data action when the source PV System group always includes storage equipment, " +
            "but the target group only permits it based on a formula. Any storage equipment data in the source group will be copied to the target."
    },
    [KEYS.setDataPvStorageAlwaysToNeverText]: {
        value:
            "The source PV System group always permits storage equipment, but the target group never does. " +
            "Note that any storage equipment data in the source group will be copied to the target by this action.",
        comment:
            "Warning text displayed for a Set Data action when the source PV System group always includes storage equipment, " +
            "but the target group never permits it. Any storage equipment data in the source group will be copied to the target."
    },
    [KEYS.setDataPvStorageFormulaToDifferentFormulaText]: {
        value:
            "The source PV System group permits storage equipment based on a formula, but the target group permits it based on a different formula. " +
            "Note that any storage equipment data in the source group will be copied to the target by this action, but it may not be appropriate for the project.",
        comment:
            "Warning text displayed for a Set Data action when the source PV System group permits storage equipment " +
            "based on a formula, but the target group permits it based on a different formula. Any storage equipment data in the source group will be copied to the target."
    },
    [KEYS.setDataPvStorageFormulaToNeverText]: {
        value:
            "The source PV System group permits storage equipment based on a formula, but the target group never permits it. " +
            "Note that any storage equipment data in the source group will be copied to the target by this action.",
        comment:
            "Warning text displayed for a Set Data action when the source PV System group permits storage equipment " +
            "based on a formula, but the target group does not permit it. Any storage equipment data in the source group will be copied to the target."
    },

    [KEYS.frequencySectionHeader]: {
        value: "Frequency",
        comment: "Header for the frequency definition section"
    },
    [KEYS.frequencyLabel]: {
        value: "How often should this Rule be applied?",
        comment: "Label for the frequency dropdown"
    },
    [KEYS.frequencyOnlyFirstTimeHelpText]: {
        value: 'The "only the first time" property is for the first time the automation is triggered, not the first time the condition is met.',
        comment: "Help text for dropdown value 'only first time'."
    },
    [KEYS.conditionSectionHeader]: {
        value: "Condition",
        comment: "Header for the condition definition section"
    },
    [KEYS.conditionValidationLabel]: {
        value: "Fire Validation and show Error Message when the following Formula is false",
        comment: "Label for the condition dropdown for validations"
    },
    [KEYS.conditionActionLabel]: {
        value: "Fire Action when the following Formula is true. Choose Always to fire every time",
        comment: "Label for the condition dropdown for actions"
    },
    [KEYS.errorMessageLabel]: {
        value: "Error Message",
        comment: "Label for error message"
    },
    [KEYS.actionSectionHeader]: {
        value: "Action",
        comment: "Header for the action definition section"
    },
    [KEYS.actionLabel]: {
        value: "What should happen automatically?",
        comment: "Label for the action type dropdown"
    },
    [KEYS.communicationTemplateHeader]: {
        value: "Communication Template",
        comment: "Label for the communication template dropdown"
    },
    [KEYS.statusHeader]: {
        value: "Status",
        comment: "Label for the status dropdown"
    },
    [KEYS.connectionConfigurationHeader]: {
        value: "Connection Configuration",
        comment: "Label for the connection configuration dropdown"
    },
    [KEYS.connectionConfigurationMissingError]: {
        value: "No connection configurations have been created.",
        comment: "No connection configurations exist error message"
    },
    [KEYS.deadlineHeader]: {
        value: "Deadline",
        comment: "Label for the deadline dropdown"
    },
    [KEYS.deadlineNoteHeader]: {
        value: "Note:",
        comment: "Header for the deadline note"
    },
    [KEYS.deadlineNoteText]: {
        value:
            "If the selected deadline definition calculates its due date based on a project data field, and " +
            "that data field is empty when the automation reaches this step, this deadline will not be set.",
        comment: "Text for the deadline note"
    },
    [KEYS.satisfyAllDeadlinesCheckboxHeader]: {
        value: "Satisfy All Deadlines",
        comment: "Text for the satisfy checkbox"
    },
    [KEYS.sourceDocumentTemplateHeader]: {
        value: "Source Document Template",
        comment: "Text for the source document template dropdown"
    },
    [KEYS.attachmentToGenerateHeader]: {
        value: "Attachment To Generate",
        comment: "Text for the attachment to generate dropdown"
    },
    [KEYS.xlsxDocumentOption]: {
        value: "XLSX Document",
        comment: "Text for the xlsx document dropdown option"
    },
    [KEYS.icsDocumentOption]: {
        value: "ICS Document",
        comment: "Text for the ics document dropdown option"
    },
    [KEYS.pdfDocumentOption]: {
        value: "PDF Document",
        comment: "Text for the pdf document dropdown option"
    },
    [KEYS.wordDocumentOption]: {
        value: "Word Document",
        comment: "Text for the Word Document dropdown option"
    },
    [KEYS.channelHeader]: {
        value: "Channel",
        comment: "Text for the channel dropdown"
    },
    [KEYS.signalHeader]: {
        value: "Signal",
        comment: "Text for the signal dropdown"
    },
    [KEYS.accessGroupHeader]: {
        value: "Access Group",
        comment: "Text for the access group dropdown"
    },
    [KEYS.removeAllAccessGroupsCheckboxHeader]: {
        value: "Remove All Access Groups",
        comment: "Text for the remove all access groups checkbox header"
    },
    [KEYS.selectReportHeader]: {
        value: "Report",
        comment: "Text for the select report selector header"
    },
    [KEYS.selectReportMessage]: {
        value:
            "Only Shared Reports from a Non-Test Environment can be selected." +
            " Reports are only run from Non-Test Environments.",
        comment: "Message for the select report selector"
    },
    [KEYS.selectESignatureEnvelopeHeader]: {
        value: "eSignature Envelope",
        comment: "Text for the select eSignature Envelope selector header"
    },
    [KEYS.continueProcessingHeader]: {
        value: "Continue Processing",
        comment: "Text for the continue processing dropdown"
    },
    [KEYS.clearDataNormalTargetLabel]: {
        value: "Data Field to clear",
        comment: "Label for the target of a clear data action"
    },
    [KEYS.stopFurtherProcessingInfoText]: {
        value: "If this action is taken the automation will stop and no subsequent action rules will be processed.",
        comment: "Text to display when 'Stop processing rules' is selected for the action rule."
    },
    [KEYS.setDataFieldTVRInfoText]: {
        value: "This data field has an associated Text Validation Rule. The automation will fail to write if the data entered violates the rule requirements.",
        comment: "Text to display when setting a data field with an associated Text Validation Rule in the action rule."
    },
    [KEYS.chooseOption]: {
        value: "Choose...",
        comment: "Text for the choose option"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
